import { render, staticRenderFns } from "./CalcFormulaConfig.vue?vue&type=template&id=01388b86&scoped=true"
import script from "./CalcFormulaConfig.vue?vue&type=script&lang=js"
export * from "./CalcFormulaConfig.vue?vue&type=script&lang=js"
import style0 from "./CalcFormulaConfig.vue?vue&type=style&index=0&id=01388b86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01388b86",
  null
  
)

export default component.exports